import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    const exchange = async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin", { state: { user: data }, replace: true });
      } catch {
        navigate("/admin", { replace: true });
      }
    };
    exchange();
  }, [location, navigate]);

  return (
    <div data-testid="auth-callback" className="flex min-h-screen items-center justify-center bg-[#0B0C0E]">
      <span className="h-2 w-2 animate-pulse rounded-full bg-[#2563EB]" />
    </div>
  );
};
